import { z } from 'zod';

export const TelegramAuthInput = z.object({
  initData: z.string().min(1),
});
export type TelegramAuthInput = z.infer<typeof TelegramAuthInput>;

export const TokenPair = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
});
export type TokenPair = z.infer<typeof TokenPair>;

export const RefreshInput = z.object({
  refreshToken: z.string(),
});
export type RefreshInput = z.infer<typeof RefreshInput>;
